import { defaultQuestionData } from '@/components/calculators/power-kits/components/Step456/QuestionModal';
import { useGlobal } from '@/utils/useGlobal';
import { Modal } from 'antd';
import css from './questionmodal.module.scss';

export default function QuestionModalH5({ isShow = false, data = defaultQuestionData, callBack }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const [visible, setVisible] = useState(isShow);
    const { t } = useLang('shared');

    useEffect(() => {
        setVisible(isShow);
    }, [isShow]);

    const handleClose = () => {
        callBack(false);
    };

    return (
        <Modal
            width={'3.55rem'}
            closable={false}
            wrapClassName={css.calculatorsmm100step4questionModalH5}
            visible={visible}
            zIndex={1000000}
            maskStyle={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000000,
                background: 'rgba(0,0,0,.45)',
                height: '100%',
            }}
        >
            <span className="questionModal-closeBtn" onClick={handleClose}>
                ×
            </span>
            <h1 className="questionModalTitle">
                {/* {data?.title} */}
                {t('calculators.mm100.step4.annotation')}
            </h1>
            <p className="questionModalText">{data?.text}</p>
        </Modal>
    );
}
